import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { studentAidesApi } from '@/services';

export const studentAidesKeys = {
  all: ['admin', 'student-aides'] as const,
  list: () => ['admin', 'student-aides', 'list'] as const,
  mine: () => ['admin', 'student-aides', 'mine'] as const,
  supportStaff: (studentId: string) => ['admin', 'student-aides', 'support-staff', studentId] as const,
};

export function useStudentSupportStaffQuery(studentId: string | undefined) {
  return useQuery({
    queryKey: studentAidesKeys.supportStaff(studentId ?? ''),
    queryFn: () => studentAidesApi.supportStaff(studentId as string),
    enabled: !!studentId,
  });
}

export function useStudentAidesQuery(enabled = true) {
  return useQuery({ queryKey: studentAidesKeys.list(), queryFn: () => studentAidesApi.list(), enabled });
}

export function useMyAideStudentsQuery() {
  return useQuery({ queryKey: studentAidesKeys.mine(), queryFn: () => studentAidesApi.mine() });
}

export function useIsAideOf(studentId: string | undefined): { isAide: boolean; isLoading: boolean } {
  const { data, isLoading } = useMyAideStudentsQuery();
  return { isAide: !!studentId && (data ?? []).some(row => row.studentId === studentId), isLoading };
}

export function useSetStudentAidesMutation(studentId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userIds: string[]) => studentAidesApi.setAides(studentId, userIds),
    onSuccess: () => qc.invalidateQueries({ queryKey: studentAidesKeys.all }),
  });
}
